export const Archive = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41.25 56.8748H18.75C10.5 56.8748 9.375 52.3748 9.375 47.4998V25.5498C9.375 24.5248 10.225 23.6748 11.25 23.6748C12.275 23.6748 13.125 24.5248 13.125 25.5498V47.4998C13.125 51.8498 13.875 53.1248 18.75 53.1248H41.25C46.125 53.1248 46.875 51.8498 46.875 47.4998V25.5498C46.875 24.5248 47.725 23.6748 48.75 23.6748C49.775 23.6748 50.625 24.5248 50.625 25.5498V47.4998C50.625 52.3748 49.5 56.8748 41.25 56.8748Z"
      fill="white"
    />
    <path
      d="M47.5 26.8745H12.5C6.45 26.8745 3.125 23.5495 3.125 17.4995V12.4995C3.125 6.44951 6.45 3.12451 12.5 3.12451H47.5C53.55 3.12451 56.875 6.44951 56.875 12.4995V17.4995C56.875 23.5495 53.55 26.8745 47.5 26.8745ZM12.5 6.87451C8.55 6.87451 6.875 8.54951 6.875 12.4995V17.4995C6.875 21.4495 8.55 23.1245 12.5 23.1245H47.5C51.45 23.1245 53.125 21.4495 53.125 17.4995V12.4995C53.125 8.54951 51.45 6.87451 47.5 6.87451H12.5Z"
      fill="white"
    />
    <path
      d="M34.5498 36.8745H25.4498C24.4248 36.8745 23.5748 36.0245 23.5748 34.9995C23.5748 33.9745 24.4248 33.1245 25.4498 33.1245H34.5498C35.5748 33.1245 36.4248 33.9745 36.4248 34.9995C36.4248 36.0245 35.5748 36.8745 34.5498 36.8745Z"
      fill="white"
    />
  </svg>
);